__webpack_require__.p = "/Fahim-Nirjon/";